<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="요청 조회"></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="id" slot-scope="props">
        <div @click="$router.push(`order_detail?id=${props.item.id}`)"
             style="cursor:pointer;text-decoration: underline">
          {{ props.item.order_num }}</div>
      </div>

      <div slot="product" slot-scope="props">
        {{ props.item.product.name }}
      </div>

      <div slot="resv_date" slot-scope="props">
        {{ props.item.resv_date }}<span v-if="props.item.resv_date !== props.item.resv_end_date"><br> ~ {{ props.item.resv_end_date }}</span>
      </div>

      <div slot="total_price" slot-scope="props">
        <div>{{ props.item.total_price | currency }}</div>
      </div>

      <div slot="is_read" slot-scope="props">
        <div v-if="props.item.is_read">확인</div>
        <div v-else>미확인</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <div v-if="props.item.status===100 || props.item.status===101">
          <button class="button half" style="margin-right:4px" @click="openModal(props.item, 200, '확정')">확정</button>
          <button class="button half" @click="openModal(props.item, 402, '취소')">취소</button>
        </div>
        <div v-else>-</div>
      </div>
    </admin-table>

    <modal name="statusChangeModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div><span v-if="selectedItem.name">{{ selectedItem.name }}님</span> 예약을 {{ selectedItem.title }} 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('statusChangeModal')">취소</button>
          <button class="button is-primary" @click="statusChange">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import BookingMixin from '@/mixins/BookingMixin'
  export default {
    name: "OrderListNew",
    mixins: [
      BookingMixin
    ],
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('order_list_new', 'booking/order?status=100');
        if(!this.isAdmin) {
          this.tableData = this.tableData.filter(item => {
            return ['partner', 'is_read'].indexOf(item.eng_name) === -1;
          });
        }
      },
      getDataFromServer() {
        this.getData();
      },
    }
  }
</script>
